module.exports = __webpack_public_path__ + "static/semilla-innovacion-6c383d42b2c2f9e7b100a34c88b6b44b.png";